import '@babel/polyfill';
import $ from 'jquery';

// device
// Determine device type based on UB's mobile breakpoint
const getDeviceWidth = () => {
    if (screen.width && window.ub !== undefined) {
        return screen.width <= window.ub.page.dimensions.mobileMaxWidth ? 'm' : 'c';
    }
    return 'm'; // Traffic is largely mobile so we use 'm' as a fallback/default.
};

// query_string
// Read entire query_string

const getQueryString = () => {
    return document.location.search;
};

// gcu
// Read gcu parameter from query_string

const getGCU = () => {
    let gcu = null;
    let matches = document.location.search.match(/(\?|&)gcu=([^&]+)/);

    if (matches !== null && matches[2] !== undefined) {
        gcu = matches[2];
    }

    return gcu;
};

// client_id
// Read GA Client ID from GA Tracker Object
// https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#getting_the_client_id_from_the_cookie

const getClientId = () => {
    let clientId = null;

    if (window.ga && typeof ga === 'function') {
        try {
            const trackers = ga.getAll();

            for (var i = 0; i < trackers.length; i++) {
                if (trackers[i].get('trackingId') === 'UA-XXXXXXXX-30') {
                    clientId = trackers[i].get('clientId');
                }
            }
        } catch (e) {
            // pass
        }
    }

    return clientId;
};

export { getDeviceWidth, getQueryString, getGCU, getClientId };
